export default __webpack_public_path__ + "static/254-4b2783bd7e15c3cc5df4232fd1750df8.gif";